import initSSA from '@/assets/js/ssa/SSABaseScript'

const SSAVuePlugin = {
  install(Vue, options) {
    const ssa = initSSA(options);
    Vue.prototype.$ssa = ssa;
    Vue.prototype.$ssaLogger = ssa.logger;
  }
}

export default SSAVuePlugin;
